// NEXUS-148 - Alice Serina - 21/10/2026
// to properly secure routes, the session information must be loaded
// before navigation so sessionStore (and by extension pinia) need 
// to be a singleton that gets imported before page loads
import { createPinia } from "pinia"; 

export const pinia = createPinia();